import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {DataService} from "../../services/data.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {IconFont} from "../../enums/icon-font";
import {OverlayService} from "../../overlay/overlay.service";
import {JobRequirement} from "../../interfaces/job-requirement";
import {CheckboxFilterComponent} from "../checkbox-filter/checkbox-filter.component";
import {SearchFilterFooterComponent} from "../search-filter-footer/search-filter-footer.component";
import {SearchFilterService} from "../search-filter.service";
import {MultiSelectTemplate} from "./multi-select-template";
import {SchoolSubjectsFilterData} from "../school-subjects-filter/school-subjects-filter-data";
import {GroupedCheckboxFilterData} from "../grouped-checkbox-filter/grouped-checkbox-filter-data";
import {CheckboxTreeFilterData} from "../checkbox-tree-filter/checkbox-tree-filter-data";
import {CheckboxFilterData} from "../checkbox-filter/checkbox-filter-data";
import {GroupedCheckboxFilterComponent} from "../grouped-checkbox-filter/grouped-checkbox-filter.component";
import {SchoolSubjectsFilterComponent} from "../school-subjects-filter/school-subjects-filter.component";
import {CheckboxTreeFilterComponent} from "../checkbox-tree-filter/checkbox-tree-filter.component";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {setUpdateArchiveView} from "../../store/actions/filter.actions";

@UntilDestroy()
@Component({
  selector: 'brt-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent implements OnInit {

  @ViewChild('mainEl') mainEl!: ElementRef<HTMLElement>;

  elementId = '';
  label = '';
  filterKey = 'selectedRequirements';

  checkboxOptions: {
    id: number;
    title: string;
    selected: boolean
  }[] = new Array(0);

  selectedOptionsNumber = 0;

  @Input('tagOnly') tagOnly = false;
  @Input('isActive') hasSelectedOptions = false;

  // Optional externally-controlled count for the badge (e.g. tagOnly chips that
  // open a custom overlay). When set, it overrides the internally tracked number.
  @Input('numberLabel') numberLabel: number | null = null;

  @Input("icon") icon!: IconFont;

  @Input('label') set setLabel(value: string) {
    this.label = value;
  }

  @Input('filter-template') template: MultiSelectTemplate = 'checkbox';

  @Input('options') set setOptions(val: GroupedCheckboxFilterData | SchoolSubjectsFilterData | CheckboxTreeFilterData | CheckboxFilterData) {
    this.options = val;
  }

  @Input('entityType') entityType: "allProfession" | "allJob" | "allProvider" | "allRookie" | "" = "";

  options!: GroupedCheckboxFilterData | SchoolSubjectsFilterData | CheckboxTreeFilterData | CheckboxFilterData;

  @Input('filter-key') set setJobFilterKey(value: string) {
    this.filterKey = value;
    // console.log("Filter key ", this.filterKey);
    this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe(response => {
      this.checkboxOptions.forEach(el => {
        el.selected = response.indexOf(el.id) > -1;
      });
    });
  }


  @Input('job-requirements') set setJobRequirementOptions(options: JobRequirement[]) {
    // console.log(this.filterKey);
    // console.log(options);
    options.forEach(option => {
      this.checkboxOptions.push({id: option.id, title: option.requirementName, selected: false})
    });
    this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe(response => {
      this.checkboxOptions.forEach(el => {
        el.selected = response.indexOf(el.id) > -1;
      });
    });
  }

  constructor(
    private data: DataService,
    private store: Store<AppState>,
    private overlay: OverlayService,
    private searchFilter: SearchFilterService
  ) {
    this.elementId = Math.random().toString(36).substring(7);
  }

  ngOnInit() {
    if(this.tagOnly) return;
    this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe(response => {
      this.hasSelectedOptions = response.length > 0;
      this.selectedOptionsNumber = response.length;
    });
  }

  openSelect() {
    if(this.tagOnly) return;

    // const filterContentType: "school_subjects" | "checkbox" | "tree" | "grouped" = "checkbox";
    this.store.dispatch(setUpdateArchiveView({updateActive: false}));
    if(this.template === "grouped") {
      this.overlay.openWindowOverlay({
        componentMain:
          {
            component: GroupedCheckboxFilterComponent,
            data: {data: this.options}
          },
        componentFooter: {
          component: SearchFilterFooterComponent,
          data: {filterKey: this.filterKey, entityType: this.entityType}
        },
        title: this.label,
        previousActiveElement: this.mainEl.nativeElement
      });

    } else if(this.template === "school_subjects") {
      if('options' in this.options) {
        this.overlay.openWindowOverlay({
          title: this.label,
          componentMain: {component: SchoolSubjectsFilterComponent, data: {options: this.options.options, filterKey: this.filterKey}},
          componentFooter: {component: SearchFilterFooterComponent, data: {filterKey: this.filterKey, entityType: this.entityType}},
          previousActiveElement: this.mainEl.nativeElement
        });
      }
    } else if(this.template === "checkbox") {
      if('options' in this.options) {
        this.overlay.openWindowOverlay({
          title: this.label,
          componentMain: {
            component: CheckboxFilterComponent,
            data: {
              options: this.options.options,
              settingsKey: this.filterKey
            }
          },
          componentFooter: {component: SearchFilterFooterComponent, data: {filterKey: this.filterKey, entityType: this.entityType}},
          previousActiveElement: this.mainEl.nativeElement

        })
      }

    } else if(this.template === 'tree') {
      // console.log(this.options);

      if('options' in this.options) {
        this.overlay.openWindowOverlay({
          title: this.label,
          componentMain: {
            component: CheckboxTreeFilterComponent,
            data: {
              options: this.options.options,
              filterKey: this.filterKey
            }
          },
          componentFooter: {component: SearchFilterFooterComponent, data: {filterKey: this.filterKey, entityType: this.entityType}},
          previousActiveElement: this.mainEl.nativeElement

        })
      }
    }
  }
}
